import React from "react";
import { Link } from "@reach/router";
import styled from "styled-components";
import { tablet } from "../responsive";
import arrow from "../assets/chevron-right-solid.svg";
const StyledNav = styled.div`
  background-color: white;
  padding: 0.5rem 2.5rem;
  ${tablet({ fontSize: "0.6rem", padding: "0.5rem" })}
  img {
    width: 0.5rem;
  }

  .second-wrapper,
  .first-wrapper {
    display: flex;
    column-gap: 0.5rem;
  }
  ul {
    display: flex;
    column-gap: 1rem;
    justify-content: space-between;
    align-items: center;

    .edit-btn {
      display: flex;
      align-items: center;
      a {
        color: #666666;
      }
    }
    .rag-btn {
      text-align: center;
      color: white;
      background-color: #ff363f;
      padding: 0.5rem;
      border-radius: 30px;
    }

    .view-btn {
      text-align: center;
      border: solid 1px black;
      padding: 0.5rem;
      border-radius: 30px;
    }
  }
`;

function InsightsNav({
  id,
  keyword,
  projectName,
  clientName,
  clubName,
  sdl,
  pdl,
  tdl,
  startDate,
  endDate,
}) {
  const title = projectName ? `${clientName} - ${projectName}` : clientName;

  return (
    <StyledNav>
      <ul>
        <div className="first-wrapper">
          <Link to={`/`}>
            <li>Go Back</li>
          </Link>
          <img alt="right-arrow" src={arrow} />
          <li>{title}</li>
        </div>

        <div className="second-wrapper">
          <li className="edit-btn">
            <Link
              state={{
                projectID: id,
                clubName: clubName,
                clientName,
                projectName,
                sdl: sdl,
                pdl: pdl,
                tdl: tdl,
                startDate: startDate,
                endDate: endDate,
              }}
              to={`/${id}/edit-client`}
            >
              Project Settings
            </Link>
          </li>

          {/* <li className="view-btn">
            <Link to={`/${id}/${keyword.toLowerCase()}`}>View {keyword}</Link>
          </li> */}

          <li className="rag-btn">
            <Link
              state={{
                projectName: projectName,
                clubName: clubName,
                clientName: clientName,
                projectID: id,
                sdl: sdl,
                pdl: pdl,
                tdl: tdl,
              }}
              to={`/${id}/new-instance`}
            >
              Create New
            </Link>
          </li>
        </div>
      </ul>
    </StyledNav>
  );
}

export default InsightsNav;
